/**
 * 
 * 全画面共通で使用する処理。
 * 
 * */

import { editInfo, greetingInfo, photo, photoUse, sonbpVp, stampInfo, uploadStampUseInfo} from "../entity/idb/editInfo";
import { orderInfo } from "../entity/idb/orderInfo";
import { ajax } from "./ajax";
import * as es6promise from "es6-promise";
import { LoginEntity, OcapiLoginRequest } from "../entity/LoginEntity";
import { dialogUtil } from "./dialog";
import { idb } from "./idb";
import { SendSaveDataEntity } from "../entity/SendSaveDataEntity";
import { constDialogMessage, constProcCd } from "./const";
import { GetCartTokenResponseEntity } from "../entity/GetCartTokenResponseEntity";
import { Logger } from "./logger";
import { GetEditInfo, retailerConfig } from "../entity";
import { retailerConfigEntity } from "../entity/retailerConfigEntity";
import { masterInfo } from "../entity/idb/masterInfo";
import { ui } from "./ui";
import { lstorage } from "./lstorage";
import { getParam } from "../entity/idb/getParam";
import { url } from "inspector";
import { stringify } from "querystring";
import { param } from "jquery";
import { SSO } from "./sso";
import { AdjustRecord } from "../util/adjustRecord";

// GIGYA
declare var gigya: any;

// WebKit
interface Window {
	webkit?: any;
	location?: any;
}
declare var window: Window;

export module common {

	// WebAPIのエンドポイント定義
	const WebAPI_SendSaveData = "Extr/SendSaveData";
	const WebAPI_OcapiLogin = "Login/Ocapi/";
	const WebAPI_GIGYALogin = "Login/GIGYA/";
	const WebAPI_LoginCheck = "Login/Check";

	const WebAPI_UpdateStatus = "Extr/UpdateStatus";
	const WebAPI_GetCartToken = "Extr/GetCartToken";

	const WebAPI_GetEditInfo = "Edit/GetEditInfo";
	const WebAPI_InitTemp = "Edit/InitTemp";


	export let _retailerConf: retailerConfigEntity;
	let _token: string = "";

	// 追加注文するときの制御
	export let pleaseQuiet = false;

	// idb関連
	const EDIT_INFO_STORENAME = "editInfo";
	const OREDER_INFO_STORENAME = "orderInfo";
	const MASTER_INFO_STORENAME = "masterInfo";

	export let isDebug = false;
	const devUrl = ["localhost", "127.0.0.1","ff-posca"];

	export function init() {

		const current = window.location.href;
		let rt = devUrl.filter(url => {
			return current.indexOf(url) > 0;
		});
		if (rt.length > 0) {
			isDebug = true;
		}

	}

	// ---------- 外向け -------------------------------------------

	/**
	 * パラメータセット
	 * @param ccgigya
	 * @param cclogincheck
	 * @param clientId
	 */
	export function SetRetailerSetting(conf: retailerConfigEntity) {
		_retailerConf = conf
	}

	/**
	 * 編集画面以外から来た時用にサーバの準備とidbの準備を行う。
	 * @param token
	 * @param editId
	 */
	export async function InitReturn(token: string) {

		// テンポラリ初期化
		let initRs = await InitTemp(token).then((rs) => {
			return rs;
		})
		if (!initRs) {
			Logger.error("テンポラリ初期失敗");
			return;
		}

		// 編集情報取得
		await GetEditInfo(token).then(async (data: GetEditInfo.GetEditInfoResponseEntity) => {

			// テンプレート期限チェック
			if (data.master.design.isExpire) {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_DESIGN_EXPIRED_TEXT, function () {
					window.location.href = common._retailerConf.orderHistory;
				});
				return;
			} else if (data.info.isExpire) {
				// 編集期限チェック
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_DATA_EXPIRED_TEXT, function () {
					window.location.href = common._retailerConf.orderHistory;
				});
				return;
			} else {
				// idbに詰め込み

				// ------editInfo --------
				Logger.info("edit info");
				var ei: editInfo = new editInfo();
				ei.retailerId = _retailerConf.id;
				ei.tempId = data.tempId;
				ei.saveAs = data.info.saveAs;
				ei.printType = data.info.printType;
				ei.dsnNo = data.master.design.dsnNo;

				// 画像アップロードデータ
				Logger.info("photoUpload Info");
				ei.photoList = new Array();
				data.info.photo.forEach((e) => {
					var p: photo = new photo();
					p.fileId = e.fileId;
					p.deleteFlg = false;
					p.fileName = e.uploadFileName;
					p.height = e.height;
					p.width = e.width;
					p.uploadDate = e.uploadDate;
					p.isUsed = e.isUsed;
					ei.photoList.push(p);
				});

				// 画像使用データ
				Logger.info("photoUse Info");
				ei.photoUseList = new Array();
				data.info.photoUse.forEach((e) => {
					var p: photoUse = new photoUse();
					p.fileId = e.fileId;
					p.useI2 = e.isUseI2;
					p.brightId = e.brightId;
					var svp: sonbpVp = new sonbpVp();
					svp.idx = e.sonbpVp.idx;
					svp.x = e.sonbpVp.x;
					svp.y = e.sonbpVp.y;
					svp.width = e.sonbpVp.width;
					svp.height = e.sonbpVp.height;
					svp.angle = e.sonbpVp.angle;
					p.sonbpVp = svp;
					ei.photoUseList.push(p);
				})

				// あいさつ文
				Logger.info("greeting Info");
				ei.greetingInfo = new Array();
				data.info.greeting.forEach((e) => {
					var g: greetingInfo = new greetingInfo();
					g.id = parseInt(e.id);
					g.greetingNo = e.greetingNo;
					g.fontId = e.font;
					g.size = e.size;
					g.colorId = e.color;
					g.outlineColor = e.outlineColor;
					g.align = e.align;
					g.text = e.text;
					g.direction = e.direction;
					var svp: sonbpVp = new sonbpVp();
					svp.idx = e.sonbpVp.idx;
					svp.x = e.sonbpVp.x;
					svp.y = e.sonbpVp.y;
					svp.width = e.sonbpVp.width;
					svp.height = e.sonbpVp.height;
					svp.angle = e.sonbpVp.angle;
					g.sonbpVp = svp;
					ei.greetingInfo.push(g);
				})

				// スタンプ
				Logger.info("stamp Info");
				ei.stampInfo = new Array();
				data.info.stamp.forEach((e) => {
					var s: stampInfo = new stampInfo();
					s.fileId = e.stampId;
					var svp: sonbpVp = new sonbpVp();
					svp.idx = e.sonbpVp.idx;
					svp.x = e.sonbpVp.x;
					svp.y = e.sonbpVp.y;
					svp.width = e.sonbpVp.width;
					svp.height = e.sonbpVp.height;
					svp.angle = e.sonbpVp.angle;
					s.sonbpVp = svp;
					ei.stampInfo.push(s);
				})

				// マイスタンプアップロード情報
				Logger.info("mystampUpload Info");
				ei.myStampList = new Array();
				data.info.myStamp.forEach((e) => {
					var p: photo = new photo();
					p.fileId = e.fileId;
					p.deleteFlg = false;
					p.fileName = e.uploadFileName;
					p.height = e.height;
					p.width = e.width;
					p.uploadDate = e.uploadDate;
					p.isUsed = e.isUsed;
					ei.myStampList.push(p);
				});

				// マイスタンプ使用データ
				Logger.info("mystampUse Info");
				ei.myStampUseList = new Array();
				data.info.myStampUse.forEach((e) => {
					var p: uploadStampUseInfo = new uploadStampUseInfo();
					p.fileId = e.fileId;
					//p.useI2 = e.isUseI2;
					var svp: sonbpVp = new sonbpVp();
					svp.idx = e.sonbpVp.idx;
					svp.x = e.sonbpVp.x;
					svp.y = e.sonbpVp.y;
					svp.width = e.sonbpVp.width;
					svp.height = e.sonbpVp.height;
					svp.angle = e.sonbpVp.angle;
					p.sonbpVp = svp;
					ei.myStampUseList.push(p);
				})

				// フォントジェニックアップロード情報
				Logger.info("fontgenicUpload Info");
				ei.fontgenicList = new Array();
				data.info.fontgenic.forEach((e) => {
					var p: photo = new photo();
					p.fileId = e.fileId;
					p.deleteFlg = false;
					p.fileName = e.uploadFileName;
					p.height = e.height;
					p.width = e.width;
					p.uploadDate = e.uploadDate;
					p.isUsed = e.isUsed;
					ei.fontgenicList.push(p);
				});

				// フォントジェニック使用データ
				Logger.info("fontgenicUse Info");
				ei.fontgenicUseList = new Array();
				data.info.fontgenicUse.forEach((e) => {
					var p: uploadStampUseInfo = new uploadStampUseInfo();
					p.fileId = e.fileId;
					p.colorId = e.colorId;
					var svp: sonbpVp = new sonbpVp();
					svp.idx = e.sonbpVp.idx;
					svp.x = e.sonbpVp.x;
					svp.y = e.sonbpVp.y;
					svp.width = e.sonbpVp.width;
					svp.height = e.sonbpVp.height;
					svp.angle = e.sonbpVp.angle;
					p.sonbpVp = svp;
					ei.fontgenicUseList.push(p);
				})

				//await idb.update<editInfo>(EDIT_INFO_STORENAME, ei);
				lstorage.set(lstorage.KEY_EDIT, ei);

				// ------orderInfo --------
				Logger.info("order Info");
				var oi: orderInfo = new orderInfo();
				oi.postcardType = data.info.postcardType + "";
				oi.num = data.info.orderNum;
				//await idb.update<orderInfo>(OREDER_INFO_STORENAME, oi);
				lstorage.set(lstorage.KEY_ORDER, oi);

				// ------masterInfo --------
				Logger.info("master Info");
				var mi: masterInfo = new masterInfo();
				mi.hagakiMasterInfo = data.master.hagaki;
				//await idb.update<masterInfo>(MASTER_INFO_STORENAME, mi);
				lstorage.set(lstorage.KEY_MASTER, mi);
			}



		});
	}


	/**
	 * 一時保存
	 * ログインチェック、ログインダイアログ表示、CC保存までのオールインワン
	 * 一時保存ボタンはこれを呼ぶ
	 * @param token
	 * @param editInfo
	 * @param orderInfo
	 * @param ccgigya
	 */
	export async function SaveData(token: string, editInfo: editInfo, orderInfo: orderInfo, customFunc: Function = null): es6promise.Promise<any> {

		// リテーラチェック
		const isFF = editInfo.retailerId == "0" ? true : false;

		// idb更新
		//await idb.update<editInfo>(EDIT_INFO_STORENAME, editInfo);
		//await idb.update<orderInfo>(OREDER_INFO_STORENAME, orderInfo);
		lstorage.set(lstorage.KEY_EDIT, editInfo);
		lstorage.set(lstorage.KEY_ORDER, orderInfo);

		// SSO
		//Logger.log("SSO開始");
		//await SSO.DoSSO(token, editInfo.retailerId);

		// ログインチェック -> テスト環境であれば固定ID返却
		const isLogin = await LoginCheck(token);

		// FFの場合、ログインダイアログの表示はGIGYAにハンドリングさせる.
		if (isFF) {

			// トークン確保
			_token = token;

			if (!isLogin) {
				// 未ログインの場合は
				await ShowGIGYALogin();

			} else {

				// ログイン済みの場合は保存/コールバック処理
				if (customFunc) {
					// 宛名選択画面は宛名遷移も含むコールバック処理を実施する。
					customFunc();
				} else {
					// 通常の画面(一時保存)
					await SaveToCommersCloud(_token);
				}
			}
		} else {

			// OCAPIの場合は自前でハンドリング
			if (!isLogin) {
				let loginOK = false;
				while (!loginOK) {
					await ShowOcapiAndLogin(token).then((data) => {
						loginOK = data;
					}).catch((e) => {
						loginOK = e;
					});
				}
			}

			if (customFunc) {
				// 宛名選択画面は宛名遷移も含むコールバック処理を実施する。
				customFunc()

			} else {
				// CC保存
				SaveToCommersCloud(token);

			}
		}
	}

	/**
	 * 強制保存 -> カート連携まで強制
	 * */
	export async function SaveDataForceForCart(token: string, isTrial:boolean = false): es6promise.Promise<any> {

		// ログインチェック -> ログイン済みであればclientIdを返す。
		dialogUtil.showLoading();
		const isLogin = await LoginCheck(token);
		dialogUtil.closeLoading();

		// カート連携処理
		let cartFunc = function () {
			common.AddCart(token, getIsEdit());
		}

		// 保存 & 非1枚無料時
		if (isLogin && !isTrial) {

			// 業務保存、CC連携、カート連携
			SaveToCommersCloud(token, cartFunc).then(() => {
				dialogUtil.closeLoading();
			});

		}else {

			// 未ログインのケースはカート連携しない。
			// ログインしていても、1枚無料であればこちらへ

			// 保存実行
			dialogUtil.showLoading();
			DoSaveBusiness(token).then(() => {
				// 業務保存後、カートに遷移
				cartFunc();
			});
		}

	}

	/**
	 * カート追加
	 * */
	export async function AddCart(token: string, editFlg: boolean): es6promise.Promise<any> {

		// カート追加
		dialogUtil.showLoading();
		let cartTokens: GetCartTokenResponseEntity;
		await GetCartToken(token).then((data: GetCartTokenResponseEntity) => {
			cartTokens = data;
		}).catch((e) => {
			// カートトークン取得失敗
			UpdateProcCd(token, constProcCd.InCartErrorPosca);
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_GET_CARTTOKEN, dialogUtil.closeErrorDialog);
			throw e;
		}).finally(() => {
			dialogUtil.closeLoading();
		});

		dialogUtil.showLoading();

		// GIGYA切り離し。。。。
		if (isDebug) {
			// ステータス更新後、GETで遷移
			UpdateProcCd(token, constProcCd.InCart).then(() => {
				window.location.href = cartTokens.cartURL;
			});
			return;
		}

		// カート追加チェック
		let ccCheckRs = 0;
		if (editFlg) {

			// 再編集の際は、カート追加チェックしない。
			ccCheckRs = 1;

		} else {

			await CheckAddCartCC(cartTokens.cartToken, cartTokens.cartCheckURL).then((data) => {

				// CC結果
				ccCheckRs = data.result.checkFlag;

			}).catch(() => {

				// CCカート追加チェック失敗
				UpdateProcCd(token, constProcCd.InCartErrorCC);
			}).finally(() => {
				dialogUtil.closeLoading();
			});
		}

		// カート追加ファンク
		var addCart = async () => {

			// Adjust登録
			try {
				new AdjustRecord(
					common._retailerConf.extrSettings.adjust?.token,
					common._retailerConf.extrSettings.adjust?.eventID.editEnd);
			} catch (er) {
				Logger.error(`AdjustError:${er}`);
			}

			dialogUtil.showLoading();
			await AddCartCC(cartTokens.cartToken, cartTokens.cartAddURL).then((data) => {

				let ccAddRs = data.result.checkFlag;

				if (ccAddRs == 1) {
					// ステータス更新後、GETで遷移
					UpdateProcCd(token, constProcCd.InCart).then(() => {
						window.location.href = cartTokens.cartURL;
					});
				} else {
					dialogUtil.closeLoading();
					UpdateProcCd(token, constProcCd.InCartErrorCC);
					dialogUtil.createErrorDialog(constDialogMessage.ERROR_ADD_CART_CHECK, dialogUtil.closeErrorDialog);
				}

			}).catch(() => {
				dialogUtil.closeLoading();
				UpdateProcCd(token, constProcCd.InCartErrorCC);
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_ADD_CART_CHECK, dialogUtil.closeErrorDialog);
			});
		}

		// カート追加
		if (ccCheckRs == 1) {

			await addCart();

		} else /*if (ccCheckRs == 2)*/ {
			// カート混在でもエラーでも9らしい。
			//UpdateProcCd(token, constProcCd.InCartDuplicateCC);
			await dialogUtil.createYesNoDialog(
				GetGIGYADuplicateMessage(),
				function () {
					dialogUtil.closeYesNoDialog();
					addCart();
				},
				dialogUtil.closeYesNoDialog,
				"OK",
				"キャンセル"
			)

		}
		//else {
		//	// カートエラー
		//	UpdateProcCd(token, constProcCd.InCartErrorCC);
		//	dialogUtil.createErrorDialog(constDialogMessage.ERROR_ADD_CART_CHECK, dialogUtil.closeErrorDialog);

		//}
	}

	/**
	 * GIGYAエラーハンドリング
	 * */
	export async function GIGYAError(): es6promise.Promise<any> {
		if (!isDebug) {
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_GIGYA_ERROR, dialogUtil.closeErrorDialog);
		}
	}

	/**
	 * カスタマーID更新
	 * @param orderInfo
	 */
	export async function UpdateCustomerId(CustomerId: string): es6promise.Promise<any> {
		// idbから取り出し
		//const oinf = await idb.get<orderInfo>(OREDER_INFO_STORENAME);
		//oinf.customerId = CustomerId;
		//await idb.update(OREDER_INFO_STORENAME, oinf);

		let oinf: orderInfo = lstorage.get<orderInfo>(lstorage.KEY_ORDER);
		oinf.customerId = CustomerId;
		lstorage.set(lstorage.KEY_ORDER, oinf);

	}

	/**
	 * OCAPIのログインダイアログを表示させます。
	 * @param token
	 * @param orderInfo
	 */
	export async function ShowOcapiAndLogin(token: string): es6promise.Promise<any> {
		let res: OcapiLoginRequest

		// ダイアログ表示
		await dialogUtil.showOCAPIDialog(_retailerConf.extrSettings.ocapi).then((rs: OcapiLoginRequest) => {
			res = rs;
		}).catch((e) => {
			throw e;
		}).finally(() => {
			dialogUtil.closeOCAPI();
		});
		Logger.log(res.loginId);

		// API実行
		dialogUtil.showLoading();

		return await loginOCAPI(_retailerConf.extrSettings.ocapi.ocapiClientId, token, res)
			.then(async (data: LoginEntity) => {

				if (data.jwt) {
					Logger.log('ログイン成功 -> /sessions 呼び出し');

					var loginRt = await CallOcapiSessions(data.jwt);

					return loginRt;

				} else {
					Logger.log('ログイン失敗');
					dialogUtil.showLoginFailedMessageOCAPI();
					return false;
				}

			}).catch(() => {
				Logger.log('ログイン失敗');
				dialogUtil.showLoginFailedMessageOCAPI();
				return false;
			}).finally(() => {
				dialogUtil.closeLoading();
			})
	}



	/**
	 * OCAPIのログインダイアログを表示させます。
	 * @param token
	 * @param orderInfo
	 */
	export async function ShowGIGYALogin(): es6promise.Promise<any> {

		if (ui.isiOS() && ui.isWebView()) {

			// WebView iOS
			window.webkit.messageHandlers.gigyaJsCallback.postMessage("");

		} else if (ui.isAndroid() && ui.isWebView()) {

			// WebView Android
			location.href = "MyPhotoBoxApp://gigya";

		}
		else {
			// gigya のダイアログ
			gigya.accounts.showScreenSet({
				screenSet: 'printsgifts-RegistrationLogin',
				authFlow: 'redirect',
				lang: 'ja'
			})
		}
		// コールバック登録は各画面から行う。
	}

	// ログイン成功後の処理　→　WebViewと共通処理にするためのラッパ
	export async function onLoginHandlerWithSave(res: any): es6promise.Promise<any> {

		await onLogin_Complete_App(res.UID, res.UIDSignature, res.signatureTimestamp);

		//dialogUtil.showLoading();

		//const param = {
		//	token: _token,
		//	uid: res.UID,
		//	signature: res.UIDSignature,
		//	sigtimestamp: res.signatureTimestamp,
		//};

		//// GIGYAログインのシグネイチャ検証
		//await ajax.post(WebAPI_GIGYALogin, JSON.stringify(param)).catch((e) => {
		//	dialogUtil.createErrorDialog(constDialogMessage.ERROR_GIGYA_SIGNATURE_INVALID, dialogUtil.closeErrorDialog);
		//	dialogUtil.closeLoading();
		//	// 検証失敗。
		//	throw e;
		//});

		//// CCとGIGYA間のログイン
		//await ajax.postform(_retailerConf.GIGYACCBridge, res.UID).catch((e) => {
		//	dialogUtil.createErrorDialog(constDialogMessage.ERROR_CC_LOGIN_WITH_GIGYA, dialogUtil.closeErrorDialog);
		//	dialogUtil.closeLoading();
		//	throw e;
		//});

		//dialogUtil.closeLoading();

		//// 名前を付けて保存ダイアログ
		//await SaveToCommersCloud(_token);
	}

	// GIGYAコールバック処理本体
	// WebView版では直接これが呼ばれるコールバック
	// 通常では、edit,hagakiSelect,preview画面からしか呼ばれない。
	// WebViewの時は、すべての画面から呼ばれる。
	export async function onLogin_Complete_App(UID, UIDSignature, signatureTimestamp): es6promise.Promise<any> {

		Logger.debug("onLogin_Complete_App start");

		const getPageName = () => {
			const locationNow: string = location.href;
			const locationNowSplit1: string[] = locationNow.split("/");
			const locationNowSplit2: string[] = locationNowSplit1[locationNowSplit1.length - 1].split("?");

			// 現在のページを取得
			return locationNowSplit2[0].toLocaleLowerCase();
		}

		const pageName = getPageName();
		if (pageName == "addorder") {

			// 追加注文の処理を呼ぶ。
			let auth = (<any>window).AddController.getAuthToken();
			const param = {
				token: auth,
				uid: UID,
				signature: UIDSignature,
				sigtimestamp: signatureTimestamp,
			};

			// GIGYAログインのシグネイチャ検証
			await ajax.post(WebAPI_GIGYALogin, JSON.stringify(param)).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_GIGYA_SIGNATURE_INVALID, dialogUtil.closeErrorDialog);
				dialogUtil.closeLoading();
				// 検証失敗。
				throw e;
			});

			// CCとGIGYA間のログイン
			await ajax.postform(_retailerConf.extrSettings.commersCloud.gigyaCcBridge, UID).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_CC_LOGIN_WITH_GIGYA, dialogUtil.closeErrorDialog);
				dialogUtil.closeLoading();
				throw e;
			});

			dialogUtil.closeLoading();

			(<any>window).AddController.doOnload();

		} else if (pageName == "atenaselect") {

			// 宛名遷移もしくは保存の処理を行う
			let auth = (<any>window).AtenaController.getAuthToken();
			const param = {
				token: auth,
				uid: UID,
				signature: UIDSignature,
				sigtimestamp: signatureTimestamp,
			};

			// GIGYAログインのシグネイチャ検証
			await ajax.post(WebAPI_GIGYALogin, JSON.stringify(param)).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_GIGYA_SIGNATURE_INVALID, dialogUtil.closeErrorDialog);
				dialogUtil.closeLoading();
				// 検証失敗。
				throw e;
			});

			// CCとGIGYA間のログイン
			await ajax.postform(_retailerConf.extrSettings.commersCloud.gigyaCcBridge, UID).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_CC_LOGIN_WITH_GIGYA, dialogUtil.closeErrorDialog);
				dialogUtil.closeLoading();
				throw e;
			});

			dialogUtil.closeLoading();

			(<any>window).AtenaController.afterGIGYACallback();

		} else {

			// 明示的に保存していない場合でもgigyaがコールバックを呼ぶ可能性がある。
			// そのため、その場合(tokenがない)は何も処理しない。
			// _tokenは明示的に保存ボタン押されないとセットされない。
			Logger.debug(`_token:${_token}`);

			if (!_token) {
				Logger.debug(`onLogin_Complete_App fired. but token is empty`);
				return;
			}

			Logger.debug("onLogin_Complete_App normal save");

			// ただの保存
			dialogUtil.showLoading();

			const param = {
				token: _token,
				uid: UID,
				signature: UIDSignature,
				sigtimestamp: signatureTimestamp,
			};

			// GIGYAログインのシグネイチャ検証
			await ajax.post(WebAPI_GIGYALogin, JSON.stringify(param)).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_GIGYA_SIGNATURE_INVALID, dialogUtil.closeErrorDialog);
				dialogUtil.closeLoading();
				// 検証失敗。
				throw e;
			});

			// CCとGIGYA間のログイン
			await ajax.postform(_retailerConf.extrSettings.commersCloud.gigyaCcBridge, UID).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_CC_LOGIN_WITH_GIGYA, dialogUtil.closeErrorDialog);
				dialogUtil.closeLoading();
				throw e;
			});

			dialogUtil.closeLoading();

			// 名前を付けて保存ダイアログ
			await SaveToCommersCloud(_token);
		}

		Logger.debug("onLogin_Complete_App end");

	}

	/**
	 * 名前を付けて入力 ~ CC連携 ~ 保存
	 * idbに保存名があるか/ないかで表示するダイアログを変える。
	 * @param tkn トークン
	 * @param closeFunc 保存ダイアログ閉じる押下時のコールバック
	 */
	export async function SaveToCommersCloud(tkn: string, closeFunc: Function = null): es6promise.Promise<any> {

		// 保存名あるか？
		const saveAsIdb = GetSaveAs();
		if (saveAsIdb) {
			// 保存名がある。 -> 上書き？新規？。
			dialogUtil.createSelectSaveMethodDialog(
				(async () => {
					// 上書き保存
					dialogUtil.closeSelectSaveMethodDialog();
					await DoSaveOverRide(tkn, saveAsIdb, closeFunc);
				})
				, (async () => {
					// 別名保存
					dialogUtil.closeSelectSaveMethodDialog();
					await DoSave(tkn, closeFunc);
				})
			);
		} else {
			// 初めての保存は名前を付けて保存
			await DoSave(tkn, closeFunc);
		}
	}

	/**
	 * 別名を付けて保存する
	 * @param tkn
	 * @param saveAs
	 * @param closeFunc
	 */
	export async function DoSave(tkn: string, closeFunc: Function): es6promise.Promise<any> {
		let saveOK = false;
		let saveAs = "";
		let isAnotherName = false; // 別名保存or新規保存

		// 業務保存結果格納
		let retBus: SendSaveDataEntity;

		// 保存OKでるまでループ
		while (!saveOK) {

			// 保存名称
			await ShowSaveAsDialog(tkn).then((data) => {
				saveAs = data;
			});
			if (saveAs.length == 0) {
				// キャンセル時
				dialogUtil.closeLoading();
				throw null;
			}

			// SFCCセッションチェック
			dialogUtil.showLoading();
			let sfccLoginStatus = await LoginCheck(tkn);
			if (!sfccLoginStatus) {
				PleaseReLogin(tkn);
				dialogUtil.closeLoading();
				throw "";
			}

			// 業務保存
			dialogUtil.showLoading();
			UpdateSaveName(saveAs);
			await DoSaveBusiness(tkn).then((data) => {
				retBus = data;
			}).catch((e) => {
				// 業務保存失敗
				UpdateProcCd(tkn, constProcCd.SaveErrorPosca).finally(() => {
					dialogUtil.closeLoading();
					Logger.log("業務保存失敗");
					throw e;
				});
			});
			dialogUtil.closeLoading();

			// CCチェック
			if (common.isDebug == false) {
				dialogUtil.showLoading();
				let ccCheckRs;
				await CheckSaveDataCC(retBus.commersCloudInfo.saveToken, retBus.commersCloudInfo.saveCheckURL).then((data) => {
					ccCheckRs = data.result.checkFlag;

				}).catch((e) => {
					// CC チェック失敗
					UpdateProcCd(tkn, constProcCd.SaveErrorCC);
					dialogUtil.closeLoading();
					dialogUtil.createErrorDialog(constDialogMessage.ERROR_CHECK_SAVE, dialogUtil.closeErrorDialog);
					throw e;
				});
				dialogUtil.closeLoading();

				if (ccCheckRs == 1) {
					// 重複なし。
					saveOK = true;
					isAnotherName = true;

				} else if (ccCheckRs == 2) {

					dialogUtil.closeSaveDialog();

					// 上書き確認
					await dialogUtil.createCheckSaveDialog().then(() => {
						// 上書きOK
						saveOK = true;
						isAnotherName = false;

					}).catch((e) => {
						// 再度名前入力ダイアログ
						saveOK = false;
						isAnotherName = true;
					});

				} else {
					UpdateProcCd(tkn, constProcCd.SaveErrorCC);
					dialogUtil.closeSaveDialog();
					dialogUtil.createErrorDialog(constDialogMessage.ERROR_CHECK_SAVE, dialogUtil.closeErrorDialog);
					throw "";
				}
			} else {
				saveOK = true;
				isAnotherName = true;
			}

		}

		// 保存
		dialogUtil.showLoading();
		if (common.isDebug == false) {

			await SaveDataCC(retBus.commersCloudInfo.saveToken, retBus.commersCloudInfo.saveURL).then(async (data) => {

				let ccSaveRs = data.result.checkFlag;
				if (ccSaveRs == 1) {

					UpdateProcCd(tkn, constProcCd.Saved);
					let func = function () {
						if (closeFunc) {
							closeFunc();
						}
						dialogUtil.closeLoading();
					}
					dialogUtil.createSaveDoneDialog(saveAs, retBus.saveDate, retBus.expireDate, func);

				} else {

					UpdateProcCd(tkn, constProcCd.SaveErrorCC);
					dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE, dialogUtil.closeErrorDialog);
				}

			}).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE, dialogUtil.closeErrorDialog);
				throw e;
			}).finally(() => {
				dialogUtil.closeLoading();
			});
		} else {

			// Debug
			UpdateProcCd(tkn, constProcCd.Saved);
			let func = function () {
				if (closeFunc) {
					closeFunc();
				}
			}
			dialogUtil.createSaveDoneDialog(saveAs, retBus.saveDate, retBus.expireDate, func);
			dialogUtil.closeLoading();
		}
	}

	/**
	 * 上書き保存する
	 * @param tkn 認証トークン
	 * @param saveAs 保存名
	 */
	export async function DoSaveOverRide(tkn: string, saveAs: string, closeFunc: Function): es6promise.Promise<any> {
		// 業務保存結果格納
		let retBus: SendSaveDataEntity;

		// 業務保存
		dialogUtil.showLoading();

		// SFCCセッションチェック
		let sfccLoginStatus = await LoginCheck(tkn);
		if (!sfccLoginStatus) {
			dialogUtil.closeLoading();
			PleaseReLogin(tkn);
			throw "";
		}

		// 業務保存
		UpdateSaveName(saveAs);
		await DoSaveBusiness(tkn).then((data) => {
			retBus = data;
		}).catch((e) => {
			// 業務保存失敗
			UpdateProcCd(tkn, constProcCd.SaveErrorPosca).finally(() => {
				dialogUtil.closeLoading();
				Logger.log("業務保存失敗");
				throw e;
			});
		});
		dialogUtil.closeLoading();

		// 保存
		dialogUtil.showLoading();
		if (common.isDebug == false) {

			await SaveDataCC(retBus.commersCloudInfo.saveToken, retBus.commersCloudInfo.saveURL).then(async (data) => {

				let ccSaveRs = data.result.checkFlag;
				if (ccSaveRs == 1) {

					UpdateProcCd(tkn, constProcCd.Saved);
					const f = function () {
						if (closeFunc) {
							closeFunc();
						}
					}
					dialogUtil.createSaveDoneDialog(saveAs, retBus.saveDate, retBus.expireDate, f);

				} else {

					UpdateProcCd(tkn, constProcCd.SaveErrorCC);
					dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE, dialogUtil.closeErrorDialog);
				}

			}).catch((e) => {
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE, dialogUtil.closeErrorDialog);
				throw e;
			}).finally(() => {
				dialogUtil.closeLoading();
			});
		} else {

			// Debug
			UpdateProcCd(tkn, constProcCd.Saved);
			const f = function () {
				if (closeFunc) {
					closeFunc();
				}
			}
			dialogUtil.createSaveDoneDialog(saveAs, retBus.saveDate, retBus.expireDate, f);
			dialogUtil.closeLoading();
		}
	}

	/**
	 * ログインチェックを行います。(CC,ポスカともに)
	 * 未ログイン時はfalse
	 */
	export async function LoginCheck(tkn: string): es6promise.Promise<any> {
		if (isDebug) {
			return true;
		}
		let rt: boolean = false;

		// CC側のログインチェック
		await ajax.getForCCLoginCheck(_retailerConf.extrSettings.ocapi.ocapiLoginCheckURL)
			.then(async (res: string) => {
				rt = res.toLocaleLowerCase() == "true" ? true : false;

				// CCのログインチェックがOKであれば、ポスカ側のログインチェックを実施する。
				if (rt) {

					let req = {
						token: tkn
					}

					// ポスカ側のログインチェック
					await ajax.post(WebAPI_LoginCheck, JSON.stringify(req))
						.then((res) => {
							rt = res.isLogind == true ? true : false;
						}).catch((e) => {
							throw e;
						});
				}

			}).catch((e) => {
				throw e;
			});

		return rt;
	}

	/**
	 * ログインチェックを行います。(CC)
	 * 未ログイン時はfalse
	 */
	export async function LoginCheckCC(tkn: string): es6promise.Promise<any> {
		if (isDebug) {
			return true;
		}
		let rt: boolean = false;

		// CC側のログインチェック
		await ajax.getForCCLoginCheck(_retailerConf.extrSettings.ocapi.ocapiLoginCheckURL)
			.then(async (res: string) => {
				rt = res.toLocaleLowerCase() == "true" ? true : false;
			}).catch((e) => {
				throw e;
			});

		return rt;
	}

	/**
	 * ログインチェックを行います。(ポスカ)
	 * 未ログイン時はfalse
	 */
	export async function LoginCheckPosca(tkn: string): es6promise.Promise<any> {
		if (isDebug) {
			return true;
		}
		let rt: boolean = false;

		let req = {
			token: tkn
		}

		// ポスカ側のログインチェック
		await ajax.post(WebAPI_LoginCheck, JSON.stringify(req))
			.then((res) => {
				rt = res.isLogind == true ? true : false;
			}).catch((e) => {
				throw e;
			});

		return rt;
	}

	/**
	 * 
	 * SFCCのログイン状態が切れているため再度ログインしてもらう。
	 * */
	async function PleaseReLogin(tkn: string): es6promise.Promise<any> {
		// idbから取り出し
		//const einf = await idb.get<editInfo>(EDIT_INFO_STORENAME);
		//const oinf = await idb.get<orderInfo>(OREDER_INFO_STORENAME);
		const einf: editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT);
		const oinf: orderInfo = lstorage.get<orderInfo>(lstorage.KEY_ORDER);

		SaveData(tkn, einf, oinf);

		// ダイアログ経由するのであれば以下を復活
		//const ReLoginFunc = function () {
		//	dialogUtil.closeErrorDialog();
		//	SaveData(tkn, einf, oinf);
		//}

		//dialogUtil.createErrorDialog(constDialogMessage.ERROR_LOGIN_SESSION_TIMEOUT, ReLoginFunc);
	}


	/**
	 * 業務保存
	 * @param token
	 * @param editInfo
	 * @param orderInfo
	 */
	async function DoSaveBusiness(token: string): es6promise.Promise<any> {
		// idbから取り出し
		//const einf = await idb.get<editInfo>(EDIT_INFO_STORENAME);
		//const oinf = await idb.get<orderInfo>(OREDER_INFO_STORENAME);
		const einf: editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT);
		const oinf: orderInfo = lstorage.get<orderInfo>(lstorage.KEY_ORDER);

		const model = {
			token: token,
			editInfo: einf,
			orderInfo: oinf
		}
		let rt: SendSaveDataEntity;
		await ajax.post(WebAPI_SendSaveData, JSON.stringify(model))
			.then((data: SendSaveDataEntity) => {
				Logger.log("保存成功しました");
				rt = data;
			}).catch((e) => {
				Logger.log("保存失敗です。");
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_SAVE_DATA, dialogUtil.closeErrorDialog);
				throw e;
			}).finally(() => {
				dialogUtil.closeLoading();
			});
		return rt;
	}

	/**
	 * 保存名称をidbに保存する。
	 * @param saveAs
	 */
	//async function UpdateSaveName(saveAs: string): es6promise.Promise<any> {
	function UpdateSaveName(saveAs: string): boolean {

		// idbから取り出し
		//let einf = await idb.get<editInfo>(EDIT_INFO_STORENAME);
		//einf.saveAs = saveAs;
		//return await idb.update(EDIT_INFO_STORENAME, einf);

		let einf: editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT);
		einf.saveAs = saveAs;
		return lstorage.set(lstorage.KEY_EDIT, einf);
	}

	/**
	 * 名前を付けて保存ダイアログ表示(CC連携あり)
	 * 戻り値：名前
	 * @param token
	 */
	async function ShowSaveAsDialog(token: string): es6promise.Promise<any> {

		// 名前入力ダイアログ
		return await dialogUtil.createSaveDialog()
			.then((data) => {
				return data;
			}).catch((e) => {
				// キャンセル押下
				return "";
			}).finally(() => {
				dialogUtil.closeSaveDialog();
			});
	}

	/**
	 * (CCに対して)データ名の重複チェックを行います。
	 */
	async function CheckSaveDataCC(token: string, url: string): es6promise.Promise<any> {
		let rt: object;
		const ccToken = "token=" + token;
		await ajax.get(url, ccToken)
			.then((data) => {
				rt = data;
			}).catch((e) => {
				throw e;
			});
		return rt;
	}

	/**
	 * (CCに対して)データの保存を行います。
	 */
	async function SaveDataCC(token: string, url: string): es6promise.Promise<any> {
		let rt: object;
		const ccToken = "token=" + token;
		await ajax.get(url, ccToken)
			.then((data) => {
				rt = data;
			}).catch((e) => {
				throw e;
			});
		return rt;
	}

	/**
	 * (CCに対して)カート追加チェックを行います
	 */
	async function CheckAddCartCC(token: string, url: string): es6promise.Promise<any> {
		let rt: object;
		const ccToken = "token=" + token;
		await ajax.get(url, ccToken)
			.then((data) => {
				rt = data;
			}).catch((e) => {
				throw e;
			});
		return rt;
	}

	/**
	 * (CCに対して)カート追加を行います
	 */
	async function AddCartCC(token: string, url: string): es6promise.Promise<any> {
		let rt: object;
		const ccToken = "token=" + token;
		await ajax.get(url, ccToken)
			.then((data) => {
				rt = data;
			}).catch((e) => {
				throw e;
			});
		return rt;
	}


	/**
	 * カートトークンを取得します。
	 * @param token
	 * @param saveAs
	 */
	async function GetCartToken(token: string): es6promise.Promise<any> {
		const model = {
			token: token
		}
		let rt: object;
		await ajax.post(WebAPI_GetCartToken, JSON.stringify(model))
			.then((data) => {
				rt = data;
			}).catch((e) => {
				throw e;
			});
		return rt;
	}

	/**
	 * OCAPIログインファクション
	 * @param clientId
	 * @param token
	 */
	async function loginOCAPI(clientId: string, token: string, Req: OcapiLoginRequest): es6promise.Promise<any> {
		let model = {
			clientId: clientId,
			loginId: Req.loginId,
			password: Req.password,
			token: token,
		}

		// webサーバへログイン
		dialogUtil.closeOCAPI(); //いったん自分を閉じる
		dialogUtil.showLoading();
		let rt: LoginEntity;
		await ajax.post(WebAPI_OcapiLogin, JSON.stringify(model)).then((data: LoginEntity) => {
			rt = data;
		}).catch((e) => {
			throw e;
		}).finally(() => {
			dialogUtil.closeLoading();
		});
		return rt;
	}

	/**
	 * OCAPIの/sessionsを実行し、ログイン状態にさせます。
	 * @param jwt
	 */
	async function CallOcapiSessions(jwt: string): es6promise.Promise<any> {
		let req = {
			type: "credentials"
		}

		const reqStr = JSON.stringify(req);

		return await ajax.postForCCSessions(_retailerConf.extrSettings.ocapi.ocapiSessionsURL, reqStr, jwt).then((data: LoginEntity) => {
			return true;
		}).catch((e) => {
			return false;
		}).finally(() => {
			dialogUtil.closeLoading();
		});
	}

	/**
	 * 注文ステータス更新
	 * @param token
	 * @param procCd
	 */
	async function UpdateProcCd(token: string, procCd: number): es6promise.Promise<any> {
		let req = {
			token: token,
			status: procCd
		}
		let rt = false;
		await ajax.post(WebAPI_UpdateStatus, JSON.stringify(req)).then((data) => {
			rt = true;
		}).catch((e) => {
			rt = false;
		});
		return rt;
	}

	/**
	 * テンポラリ初期
	 * @param token
	 */
	async function InitTemp(token: string): es6promise.Promise<any> {
		let rt = false;
		let req = {
			token: token
		}
		await ajax.post(WebAPI_InitTemp, JSON.stringify(req)).then((data) => {
			rt = true;
		});
		return rt;
	}

	/**
	 * 編集情報取得
	 * @param token
	 */
	async function GetEditInfo(token: string): es6promise.Promise<any> {
		let rt;
		let req = {
			token: token
		}
		await ajax.post(WebAPI_GetEditInfo, JSON.stringify(req)).then((data) => {
			rt = data;
		});
		return rt;
	}
	export function GetSaveAs(): string {

		let rt = "";

		const ei: editInfo = lstorage.get<editInfo>(lstorage.KEY_EDIT);
		if (ei) {
			if (ei.saveAs) {
				rt = ei.saveAs;
			}
		}
		return rt;
	}

	/*
	 *GIGYA重複時のメッセージ
	 * */
	function GetGIGYADuplicateMessage(): string {

		return "カートに商品があるため、編集中の商品データを追加できませんでした。</br>"
			+ "・現在編集中の商品データをカートへ入れる場合は【OK】を押してください。</br>"
			+ "・編集画面に戻る場合は【キャンセル】を押してください。</br>"
			+ "※年賀状を含むポストカードは、カートに1つしか商品を入れられないため上書きされます。</br>"
			+ "&emsp;現在カートにある商品を確認するにはサイトトップへ戻りカートをご確認ください。</br>"
			;
	}

	/**
	 * 再編集かフラグ
	 */
	function getIsEdit(): boolean {

		// hiddenから途中フラグ取得
		let v = ($("#isEdit").val() + "").toLowerCase();
		if (v == "true") return true;
		return false;
	}

	/**
	 * タイムスタンプを取得する。
	 * */
	export function getTimeStamp(): string {
		const date = new Date()
		const Y = date.getFullYear()
		const M = ("00" + (date.getMonth() + 1)).slice(-2)
		const D = ("00" + date.getDate()).slice(-2)
		const h = ("00" + date.getHours()).slice(-2)
		const m = ("00" + date.getMinutes()).slice(-2)
		const s = ("00" + date.getSeconds()).slice(-2)
		const f = ("000" + date.getMilliseconds()).slice(-3)

		return Y + M + D + h + m + s + f
	}

	/**
	 * URLから、GETパラメータを取得しローカルストレージに格納しておく。
	 * @param urlParam
	 */
	export function setGetParam(): void {

		/// Getパラメーターを記録する配列
		var params = {};

		/// URLからパラメーター解析＆取得
		var query = window.location.href.split("?")[1];
		if (query) {
			var rawParams = query.split('&');
			rawParams.forEach(function (prm, i) {
				var kv = prm.split('=');
				params[kv[0]] = kv[1];
			});
		}

		// ローカルストレージに入れる準備
		let rs = new getParam();
		Object.keys(params).forEach(function (name, i) {
			let tmpKey = name.toLowerCase();
			if (tmpKey == "designno") {
				rs.designNo = this[name];

			} else if (tmpKey == "retailerid") {
				rs.retailerId = this[name];

			} else if (tmpKey == "trial") {
				rs.trial = this[name];

			} else if (tmpKey == "returnurl") {
				rs.returnUrl = this[name];

			} else if (tmpKey == "saveid") {
				rs.saveId = this[name];

			} else if (tmpKey == "saveid2") {
				rs.saveId2 = this[name];

			} else if (tmpKey == "addorder") {
				rs.addOrder = this[name];

			} else if (tmpKey == "cart_line_key") {
				rs.cart_line_key = this[name];

			} else if (tmpKey == "printtype") {
				rs.printType = this[name];
			} 
		}, params);

		lstorage.set<getParam>(lstorage.KEY_GETPARAM,rs);
	}

	/**
	 * 編集画面遷移用のパラメータを取得します。
	 * */
	export function getGetParam(): string {

		let gparam = lstorage.get<getParam>(lstorage.KEY_GETPARAM);

		let rt = "";

		// 先頭は?、続きは&となるようにする。
		function hatenaOrAnd() {
			if (rt.length == 0) {
				return "?";
			} else {
				return "&";
			}
		}

		if (gparam.designNo) {
			rt += hatenaOrAnd() + "designNo=" + gparam.designNo;
		}

		if (gparam.retailerId) {
			rt += hatenaOrAnd() + "retailerId=" + gparam.retailerId;
		}

		if (gparam.trial) {
			rt += hatenaOrAnd() + "trial=" + gparam.trial;
		}

		if (gparam.returnUrl) {
			rt += hatenaOrAnd() + "returnURL=" + gparam.returnUrl;
		}

		if (gparam.saveId) {
			rt += hatenaOrAnd() + "saveId=" + gparam.saveId;
		}

		if (gparam.saveId2) {
			rt += hatenaOrAnd() + "saveId2=" + gparam.saveId2;
		}

		if (gparam.addOrder) {
			rt += hatenaOrAnd() + "addOrder=" + gparam.addOrder;
		}

		if (gparam.cart_line_key) {
			rt += hatenaOrAnd() + "cart_line_key=" + gparam.cart_line_key;
		}

		if (gparam.printType) {
			rt += hatenaOrAnd() + "printType=" + gparam.printType;
		}

		return rt;

	}
}

(<any>window).CommonFunc = common;